var OHY = OHY || {};

OHY.mq = {
    'sm': '(min-width: 576px)',
    'md': '(min-width: 768px)',
    'lg': '(min-width: 992px)',
    'xl': '(min-width: 1200px)'
};

OHY.init_menu = function () {
    var toggle = $('button.menu-toggle');

    if (!toggle.length) {
        return;
    }

    toggle.click(function () {
        $('body').toggleClass('menu-active');
    });
}

OHY.init_testimonials = function () {
    var sliders = $('.testimonials');

    if (!sliders.length) {
        return;
    }

    sliders.flickity({
        wrapAround: true,
        arrowShape: 'M70 97.93L67.122 100 31 49.103 67.14 0l2.842 2.12-34.607 47.022z'
    });
};

OHY.init_anchor_links = function () {
    $('a').on('click', function (e) {
        var href = $(this).attr('href'),
            target,
            offset,
            top;

        if (href.indexOf('#') !== 0 ) {
            return;
        }

        target = $(href);

        if (!target.length) {
            return;
        }

        e.preventDefault();

        offset = window.innerWidth >= 992 ? 135 : 62;
        top = target.offset().top - offset;

        $('html, body').animate({
            scrollTop: top
        }, 1000);
    });
};

OHY.calculate_bmi = function (pounds, inches) {
    return 703 * pounds / (inches*inches);
}

OHY.init_bmi_calculator = function () {
    var button = $('button.calculate-bmi'),
        feedback = $('label.bmi_feedback'),
        input = $('input[name="fields[quizBMI]"]');

    if (!button.length) {
        return;
    }

    button.on('click', function () {
        var weight = $('input#weight').val(),
            height_feet = $('input#height_feet').val(),
            height_inches = $('input#height_inches').val(),
            inches,
            bmi;

        // If any field isNaN, show an error, clear the field, and return
        if (isNaN(weight) || isNaN(height_feet) || isNaN(height_inches)) {
            feedback.show().text('Please only enter numbers.');

            if (isNaN(weight)) { $('input#weight').val(''); }
            if (isNaN(height_feet)) { $('input#height_feet').val(''); }
            if (isNaN(height_inches)) { $('input#height_inches').val(''); }

            return;
        }

        // If any field is empty, show an error and return
        if (weight == '' || height_feet == '' || height_inches == '') {
            feedback.show().text('Please enter weight and height.');

            return;
        }

        inches = (height_feet * 12) + (height_inches*1);
        bmi = OHY.calculate_bmi(weight, inches);
        bmi = Math.round(bmi * 10) / 10;

        feedback.show().html('Your BMI is <strong>' + bmi + '</strong>');
        input.val(bmi).trigger('change');
    });
};

OHY.init_quiz = function () {
    var section = $('section.quiz'),
        form = section.find('form.quiz'),
        slider = section.find('.quiz-slider'),
        fieldsets = slider.find('fieldset'),
        previous = section.find('.quiz-previous'),
        next = section.find('.quiz-next'),
        inputs = section.find('input, textarea'),
        progress = 0,
        progress_label = section.find('.progress .label'),
        progress_indicator = section.find('.progress .indicator'),
        submit = section.find('.submit');

    if (!section.length) {
        return;
    }

    var checkFieldsetValidity = function (fieldset) {
        var fieldset_inputs = fieldset.find('input, textarea'),
            fieldset_checkbox_groups = fieldset.find('.checkbox-group-required');

        next.prop('disabled', false);
        submit.prop('disabled', false);

        fieldset_inputs.each(function () {
            if (!this.checkValidity()) {
                next.prop('disabled', true);
                submit.prop('disabled', true);
                return;
            }
        });

        fieldset_checkbox_groups.each(function () {
            if (!$(this).find(':checked').length) {
                next.prop('disabled', true);
                submit.prop('disabled', true);
                return;
            }
        });
    };

    inputs.on('change keyup', function () {
        var fieldset = $(this).closest('fieldset');
        checkFieldsetValidity(fieldset);
    });

    slider.on('select.flickity', function(event, index) {
        // Default to 0 if undefined
        index = isNaN(index) ? 0 : index;

        // Update progress
        progress = index / (fieldsets.length - 1);
        progress_label.text(Math.round(progress*100) + '%');
        progress_indicator.css('transform', 'scaleX(' + progress + ')');

        // Check fieldset validity
        var fieldset = fieldsets.eq(index);
        checkFieldsetValidity(fieldset);

        // Disable tabindex on hidden inputs
        form.find('button, input, textarea').attr('tabindex', -1);
        fieldset.find('button, input, textarea').attr('tabindex', '');

        // Disable previous button on first slide
        previous.prop('disabled', index == 0);

        // Show submit button on last slide
        if (index == fieldsets.length - 1) {
            next.hide();
            submit.show();
        } else {
            next.show();
            submit.hide();
        }

        // Scroll to top of form if not visible
        var scrollOffset = window.innerWidth >= 992 ? 135 : 62,
            formOffset = section.find('.bg').offset(),
            formTop = formOffset ? formOffset.top : Infinity;

        if (window.scrollY > formTop) {
            $('html, body').animate({
                scrollTop: formTop - scrollOffset
            }, 1000);
        }
    });

    slider.flickity({
        draggable: false,
        pageDots: false,
        prevNextButtons: false
    });

    previous.on('click', function () {
        slider.flickity('previous');
    });

    next.on('click', function () {
        slider.flickity('next');
    });

    var showQuizResults = function (results) {
        var height = section.height(),
            oldContainer = section.find('.container'),
            newContainer = $(results).addClass('hide');

        // Set fixed height so page doesnt jump around
        section.css('height', height);

        // Hide the old container
        oldContainer.addClass('hide');

        // Replace the content
        window.setTimeout(function () {
            oldContainer.remove();
            section.append(newContainer);
        }, 500);

        // Show the container
        window.setTimeout(function () {
            newContainer.removeClass('hide');

            // Remove fixed height
            section.css('height', 'auto');
        }, 510);
    }

    submit.on('click', function () {
        var data = form.serialize(),
            action = form.attr('action');

        // Disable buttons
        previous.prop('disabled', true);
        submit.text('Submitting...').prop('disabled', true);

        $.post(action, data, function (response) {
            if (!response.success) {
                alert('There was an error submitting your quiz.');
                return;
            }

            // Load results fragment into page
            // $.get('/healthyyou/results', {entryId: response.id}, function (results) {
            //     showQuizResults(results);
            // });

            // Redirect to results page
            window.location.href = '/healthyyou/results/' + response.id;

        }, 'json').fail(function () {
            alert('There was an error submitting your quiz.');
            return;
        });
    });
};

OHY.init_external_links = function () {
  if ( window.location.href.match("healthyyou") ) {
    $('a').each(function() {
        var a = new RegExp('/' + window.location.host + '/');

        if (!a.test(this.href)) {
            $(this).attr('target', '_blank');
        }
    });
  }
};

$(document).ready(function () {
    OHY.init_menu();
    OHY.init_testimonials();
    OHY.init_anchor_links();
    OHY.init_bmi_calculator();
    OHY.init_quiz();
    OHY.init_external_links();
});
